const generateRandomString = () =>
  (Math.random() + 1).toString(36).substring(7);

export const generators = {
  generateRandomString,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/generators.js